import { createContext, useContext } from 'react';

import noop from 'utils/noop';

export type DynamicHeatmapDrawerContextState = {
  collapse: () => void;
  expand: () => void;
  toggle: () => void;
  isExpanded: boolean;
};

export const defaultDynamicHeatmapDrawerContextState = {
  collapse: noop,
  expand: noop,
  toggle: noop,
  isExpanded: false,
};

export const DynamicHeatmapDrawerContext = createContext<DynamicHeatmapDrawerContextState>(
  defaultDynamicHeatmapDrawerContextState,
);

export const useDynamicHeatmapDrawerContext = () => useContext(DynamicHeatmapDrawerContext);
